import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "notices"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "站内消息")], -1);

const _hoisted_4 = {
  class: "panel-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
    data: $data.notice_list,
    border: "",
    size: "mini",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      property: "create_time",
      label: "贴出时间",
      width: "160px",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.$filters.time(scope.row.create_time)), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "title",
      label: "标题",
      align: "center",
      width: "200"
    }), _createVNode(_component_el_table_column, {
      property: "text",
      label: "消息详情"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_pagination, {
    class: "paging",
    "hide-on-single-page": "",
    onCurrentChange: $options.change_page,
    small: "",
    modelValue: $data.page,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.page = $event),
    "page-size": $data.limit,
    "pager-count": 5,
    total: $data.pagination.total_records * 1,
    layout: " total,prev, pager, next, jumper,"
  }, null, 8, ["onCurrentChange", "modelValue", "page-size", "total"])])])]);
}